export const infoMessage = undefined;